module.exports = __webpack_public_path__ + "img/clipboard-text-outline.3abe0ded.svg";